/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # ROC Selections Module

define('modules/Product/ProductService',[
    'jquery',
    'global/Logger',
    'global/Constants'
], function ($, Logger, Constants) {
    'use strict';
    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var products = {};

    function getById(id) {
        return getUsingCache(apiUrl + '/api/product/' + id + '/', id);
    }

    function getByIdAndUom(id, uomId) {
        return getUsingCache(apiUrl + '/api/product/' + id + '/uom/' + uomId, id, uomId);
    }

    function getUsingCache(url, productId, uomId) {
        var uomCacheKey = uomId ? "_" + uomId : ""; 
        var cacheKey = productId + uomCacheKey;

        var deferred = $.Deferred();
        if (products[cacheKey] !== undefined) {
            Logger.info('ProductService -> getById: getting product from cache...');
            deferred.resolve(products[cacheKey]);
        } else {
            Logger.info('ProductService -> getById: getting product from the api...');
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json'
            }).done(function (product) {
                products[cacheKey] = product;
                deferred.resolve(product);
            }).fail(function () {
                deferred.reject();
            });
        }
        return deferred;
    }


    function getRecentlyViewedProducts(ids) {
        return $.ajax({
            url: apiUrl + '/api/product/recentlyViewedItems',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(ids)
        });
    }

    function getProductPricing(id) {
        return $.ajax({
            url: apiUrl + '/api/product/' + id + '/pricingViewModel',
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json',
        });
    }

    function loadProductsPricing(ids) {
        return $.ajax({
            url: apiUrl + '/api/product/pricinglist',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(ids)
        });
    }

    /**
     * Indicates whether "Add to Cart" button should be displayed or not.
     * Please note that there's a similar function
     * Roc.Sitefinity.SDK\Extensions\ProductViewModelExtensions.cs
     * which is an extension method. Any changes must be applied in both files to keep it consistent.
     * @param {} product 
     * @returns {} 
     */
    function addToCartButtonDisplay(product) {
        if (!product) {
            return false;
        }
        switch (product.productType) {
            case Constants.enums.productType.Group:
                return !product.inventoryStatus || product.inventoryStatus === Constants.enums.inventoryAction.BACKORDER;
            default:
                return product.canAddProduct;
        }
    }

    var ProductService = {
        addToCartButtonDisplay: addToCartButtonDisplay,
        getById: getById,
        getByIdAndUom: getByIdAndUom,
        getRecentlyViewedProducts: getRecentlyViewedProducts,
        getProductPricing: getProductPricing,
        loadProductsPricing: loadProductsPricing,
    };

    Logger.debug('ProductService.js Loaded:', ProductService);

    return ProductService;
});
